module.exports = __webpack_public_path__ + "img/back.374157d3.webp";